export function getPageCount (response) {
  const headerPageCount = +response?.headers?.['x-pagination-page-count']
  if (headerPageCount) return headerPageCount

  return +response?.data?.last_page ||
    +response?.data?.meta?.last_page ||
    0
}

export function createPageList (pageCount) {
  return [
    ...Array(Number(pageCount))
      .keys()
  ].map(i => ++i)
}
